import { MenuProps } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";

type MenuItem = Required<MenuProps>["items"][number];

export function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group",
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

export function generateAvatarColor(username: any) {
  // You can use a hash function to generate a consistent color based on the username
  let hash = 0;
  for (let i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Generate a hexadecimal color code
  const color = `#${((hash & 0x00ffffff) | 0x808080).toString(16)}`;
  return color;
}

export function CheckInput(inputValue: any) {
  if (inputValue) {
    return inputValue;
  }

  return "-";
}

export function FormatDateYMD(inputDate: any) {
  const formatDate = dayjs(inputDate).format("YYYY-MM-DD");
  return formatDate;
}

export function FormatDateYMDHMS(inputDate: any) {
  if (inputDate === "None" || !inputDate) {
    return "-";
  }

  const formattedDate = dayjs(inputDate).format("YYYY-MM-DD HH:mm:ss");
  return formattedDate;
}

export function FormatDateYM(inputDate: any) {
  const formatDate = dayjs(inputDate).format("YYYY-MM");
  return formatDate;
}

export function FormateFullDate(inputDate: any) {
  const formatDate = dayjs(inputDate).format("ddddที่ D MMMM YYYY");
  return formatDate;
}

export function FormatTime(inputTime: any) {
  const formatTime = dayjs(inputTime).format("HH");
  return formatTime;
}

export const disabledPrevDate: RangePickerProps["disabledDate"] = (current) => {
  return current < dayjs().startOf("day");
};

export function ConvertCarType(input: any) {
  switch (input) {
    case "normal":
      return "รถรอบธรรมดา";
    case "extra":
      return "รถรอบพิเศษ";
    default:
      break;
  }
}

export function GetColor(input: any) {
  switch (input) {
    case "picked":
      return "volcano";
    case "packed":
      return "blue";
    case "ready":
      return "magenta";
    case "complete":
      return "green";
    case "unoperate":
      return "#9E9E9E"; // Grey - Indicating inactive or not operated
    case "checked out":
      return "#2E7D32"; // Green - Checked out
    case "shipping":
      return "#FFD54F"; // Amber - In transit/shipping
    case "waiting":
      return "#FFB74D"; // Orange - Waiting for action
    case "cancel":
      return "#E57373"; // Red - Cancelled
    case "return":
      return "#BA68C8"; // Purple - Returned items
    case "confirm":
      return "#7986CB"; // Indigo - Confirmed status
    default:
      return "gold";
  }
}

export function ConvertDeliveryTime(start: any, end: any) {
  return `${dayjs(start).add(-7, "hour").add(18, "minute").format("HH:mm")} - ${dayjs(end)
    .add(-7, "hour")
    .add(18, "minute")
    .format("HH:mm")}`;
}

export function AvailableDatePicker(available: any, current: any) {
  const mappedAvailable = available.map((e: any) => dayjs(e).format("YYYY-MM-DD"));
  const currentDate = current.format("YYYY-MM-DD");
  return !mappedAvailable.includes(currentDate);
}

export function SwitchStatus(status: any) {
  switch (status) {
    case 1:
      return "Scheduled";
    case 2:
      return "Confirmed";
    case 3:
      return "Pic-Pack";
    case 4:
      return "Delivery";
    case 5:
      return "Completed";
    case 6:
      return "Cancelled";
    case 7:
      return "Uncompleted";
    default:
      break;
  }
}

export function SwitchAssem(assembling: any) {
  switch (assembling) {
    case 0:
      return "ทีมจัดส่ง (BI)";
    case 1:
      return "ทีมจัดส่งและประกอบ";
    default:
      break;
  }
}

export async function PlaySound(status: "success" | "error" | "duplicate"): Promise<void> {
  const sounds = {
    success: new Audio("/sound/success.mp3"),
    error: new Audio("/sound/error.mp3"),
    duplicate: new Audio("/sound/scanned.mp3"),
  } as const;
  try {
    const sound = sounds[status];
    sound.currentTime = 0; // รีเซ็ตให้เล่นจากต้นได้ ถ้าเสียงยังไม่จบ
    await sound.play();
  } catch (error) {
    console.warn("Unable to play sound:", error);
  }
}
